/**
 * 时尚黑色主题颜色值
 */

/* 字体颜色 */
const color_header_secondary = 'rgba(255, 255, 255, 0.65)';
const color_chat_name = 'rgba(255, 255, 255, 0.45)';
const color_chat_primary = 'rgba(255, 255, 255, 0.85)';
const color_send_color = 'rgba(255, 255, 255, 0.45)';
const color_tab_text = '#fff';
const color_text_active = '#FB2626';
const color_subscribe_primary = 'rgba(255, 255, 255, 0.65)';
const color_subscribe_secondary = '#fff';
const color_intro_text = 'rgba(255, 255, 255, 0.65)';
const color_doc_tools_text = '#FFFFFF';

/* 背景颜色 */
const background_header_color = 'transparent'; //顶部背景
const background_footer_color = 'transparent'; //顶部背景
const background_tabs_color = 'transparent'; //tabs背景
const background_chat_color = 'rgba(0, 0, 0, 0.25)'; //聊天文案背景
const background_send_color = 'rgba(255, 255, 255, 0.1)'; //发送输入框文案背景
const background_color_active = '#FB2626';
const background_subscribe_text = '#333';
const background_doc_tools_color = 'rgba(0, 0, 0, 0.45)'; //wap观看端文档工具颜色
// 边框颜色
const border_tabs_color = 'rgba(0, 0, 0, 0.45)'; //tabs下边框

export default {
  '--color_header_secondary': color_header_secondary,
  '--color_chat_name': color_chat_name,
  '--color_chat_primary': color_chat_primary,
  '--color_send_color': color_send_color,
  '--color_tab_text': color_tab_text,
  '--color_text_active': color_text_active,
  '--color_subscribe_primary': color_subscribe_primary,
  '--color_subscribe_secondary': color_subscribe_secondary,
  '--color_intro_text': color_intro_text,
  '--color_doc_tools_text': color_doc_tools_text,
  '--background_header_color': background_header_color,
  '--background_tabs_color': background_tabs_color,
  '--background_chat_color': background_chat_color,
  '--background_send_color': background_send_color,
  '--background_color_active': background_color_active,
  '--border_tabs_color': border_tabs_color,
  '--background_footer_color': background_footer_color,
  '--background_subscribe_color': background_subscribe_text,
  '--background_doc_tools_color': background_doc_tools_color
};
